import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs';
import { quizActions } from '../actions/quizes.actions';
import { selectQuiz, selectQuizLoaded, selectQuizLoading } from '../selectors/quizes.selectors';

@Injectable({
    providedIn: 'root',
})
export class QuizFacade {
    private readonly store = inject(Store);

    // Observable selectors
    quiz$ = (id: string) => this.store.select(selectQuiz(id));
    quizNonNullable$ = (id: string) => this.quiz$(id).pipe(filter((quiz) => quiz !== null));
    loading$ = (id: string) => this.store.select(selectQuizLoading(id));
    loaded$ = (id: string) => this.store.select(selectQuizLoaded(id));

    // Signal selectors
    quiz = (id: string) => this.store.selectSignal(selectQuiz(id));
    loading = (id: string) => this.store.selectSignal(selectQuizLoading(id));
    loaded = (id: string) => this.store.selectSignal(selectQuizLoaded(id));

    // Actions
    getQuiz(id: string): void {
        this.store.dispatch(quizActions.getQuiz({ id }));
    }

    clear(id: string): void {
        this.store.dispatch(quizActions.clear({ id }));
    }

    clearAll(): void {
        this.store.dispatch(quizActions.clearAll());
    }
}
